import React, { useState, useRef, useEffect } from "react";
import axios from "../axios";
import ClipLoader from "react-spinners/ClipLoader";
import { CustomSlider } from "./Common/CustomSlider";
import "../Assets/styles/newStyles/Imbrications.css";


export const Imbrications = (props) => {

  const {updatedImbricationsFunction}= props

 

//  const [response,setResponse] = useState({})
  const [risk_s, setRisk] = useState(props.risk_s);
  const [tb_s, setTb] = useState(props.tb_s);
  const [pattern_s, setPattern] = useState(props.pattern_s);
  const [covid_s, setCovid] = useState(props.covid_s);

 
  // console.log(risk, tb, pattern, covid)

  useEffect(()=>{
    updatedImbricationsFunction({ risk_s, pattern_s, covid_s, tb_s }); 
  },[risk_s, covid_s, pattern_s, tb_s])


 
 

  const handleRiskButton = (add, minus) => {
    if (add == true) {
      if (risk_s != 2) {
        setRisk(risk_s + 1);
        
      }
    }
    if (minus == true) {
      if (risk_s!= 0) {
        setRisk(risk_s - 1);
      }
    }
  };
  const handleTbButton = (add, minus) => {
    if (add == true) {
      if (tb_s != 2) {
        setTb(tb_s + 1);
      }
    }
    if (minus == true) {
      if (tb_s!= 0) {
        setTb(tb_s - 1);
      }
    }
  };
  const handlePatternButton = (add, minus) => {
    if (add == true) {
      if (pattern_s != 2) {
        setPattern(pattern_s + 1);
      }
    }
    if (minus == true) {
      if (pattern_s != 0) {
        setPattern(pattern_s - 1);
      }
    }
  };
  const handleCovidButton = (add, minus) => {
    if (add == true) {
      if (covid_s != 2) {
        setCovid(covid_s + 1);
      }
    }
    if (minus == true) {
      if (covid_s != 0) {
        setCovid(covid_s - 1);
      }
    }
  };
  const handleRiskChange = (event) => {
    setRisk(event.target.value);
    
 
  };
  const handleTbChange = (event) => {
    setTb(event.target.value);

  };
  const handlePatternChange = (event) => {
    setPattern(event.target.value);
   
  };
  const handleCovidChange = (event) => {
    setCovid(event.target.value);
   
  };

 

  return (
    <div>
      <h1 className="imbrications-heading">Imbrications</h1>
      {/* {response === "" ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "55vh",
          }}
        >
          <ClipLoader color={"orange"} size={30} />
        </div>
      ) : ( */}
        <div>
          <CustomSlider
            prefix="Risk Sensitivity"
            heading="Sensitivity"
            value={risk_s}
            handleChange={handleRiskChange}
            handleButton={handleRiskButton}
            
          />
          <CustomSlider
            prefix="Pattern Sensitivity"
            heading="Sensitivity"
            value={pattern_s}
            handleChange={handlePatternChange}
            handleButton={handlePatternButton}

          />
          {localStorage.plan ==='covid' &&  <CustomSlider
            prefix="Covid Sensitivity"
            heading="Sensitivity"
            value={covid_s}
            handleChange={handleCovidChange}
            handleButton={handleCovidButton}
          />}
         {localStorage.Tb==='tb' && <CustomSlider
            prefix="TB Sensitivity"
            heading="Sensitivity"
            value={tb_s}
            handleChange={handleTbChange}
            handleButton={handleTbButton}
          />}
          
        </div>
      {/* )} */}
    </div>
  );
};